import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import api from "@/api/index"
import { router, VueRouter } from "@/router"
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(ElementUI, { size: "mini" });
Vue.prototype.$api = api;
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
